import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BOProduct, UnitPrice } from '@boels/models';
import { UserTypeService } from '@boels/helpers';

@Injectable({
  providedIn: 'root',
})
export class PriceService implements OnDestroy {
  private subs$ = new Subscription();
  userTypeService = inject(UserTypeService);

  getPrices(product: BOProduct, isBusiness: boolean): UnitPrice[] {
    return (product.unitPrices as UnitPrice[])
      ?.filter(
        (price: UnitPrice) =>
          (!isBusiness && !price.netPrice) || (isBusiness && price.netPrice),
      )
      .map((filteredPrices: UnitPrice) => filteredPrices);
  }

  getVatLabel(isPLP?: boolean): string {
    if (isPLP) {
      return this.userTypeService.isIndividualUser()
        ? 'productGrid.labelInclVat'
        : 'productGrid.labelExclVat';
    } else {
      return this.userTypeService.isIndividualUser()
        ? 'productDetails.labelInclVat'
        : 'productDetails.labelExclVat';
    }
  }

  getPricesForUserType(product: BOProduct): UnitPrice[] {
    return this.userTypeService.isIndividualUser()
      ? this.getPrices(product, false)
      : this.getPrices(product, true);
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
